// Typed values for the `?error=` query param on the /login page.
// Shared between lib/ (URL builder) and features/auth/ (URL parser).
export type LoginErrorCode = "no-organization-found"
export const LOGIN_NO_ORG_ERROR_CODE: LoginErrorCode = "no-organization-found"
